export default __webpack_public_path__ + "1d0e6b93feea847772647cef0ec5cc94.png";